import React, { useEffect, useState } from 'react';
import { func, shape, string } from 'prop-types';

import SampleIntervalSelect from '../FormFields/SampleIntervalSelect';

const BacnetSampleIntervalSelect = ({
    name,
    onChange,
    rowData,
    ...props
}) => {
    const [value, setValue] = useState(15);

    useEffect(() => {
        if (rowData.sampleInterval && rowData.sampleInterval !== 15) {
            setValue(rowData.sampleInterval);
        }
    }, [rowData]);

    function handleChange(event) {
        const { value } = event.target;

        rowData.sampleInterval = value;

        setValue(value);
        onChange(rowData);
    }

    return (
        <SampleIntervalSelect
            name={name}
            onChange={handleChange}
            showLabel={false}
            type={rowData.dataType}
            value={value}
        />
    );
};

BacnetSampleIntervalSelect.defaultProps = {
    onChange: () => {},
    rowData:  {}
};

BacnetSampleIntervalSelect.propTypes = {
    name:     string,
    onChange: func,
    rowData:  shape({
        id: string
    })
};

export default BacnetSampleIntervalSelect;
